import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Accordion from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Accordion';
import AccordionSummary from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/AccordionSummary';
import AccordionDetails from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/AccordionDetails';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import Link from '@material-ui/core/Link';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { LEGAL_DOCUMENT_MAP } from 'Consts/LegalDocuments';

import useMobileLayout from 'Hooks/useMobileLayout';
import { lighten } from '@material-ui/core/styles/colorManipulator';

const styles = (theme) => ({
  root: {
    width: '100%',
  },
  heading: {},
  accordion: {
    backgroundColor: theme.palette.facet.accentBlue21,
    padding: theme.spacing(2),
    borderRadius: theme.radius.md,
  },
  roundedAccordion: {
    borderRadius: theme.radius.md,
  },
  linksWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  mobileAgreementLink: {
    padding: theme.spacing(3, 0),
    borderBottom: `1px solid ${lighten(theme.palette.facet.primaryBlue, 0.8)}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
});

const ClientAgreementFinePrint = ({
  className,
  classes,
}) => {
  const isMobile = useMobileLayout();
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Accordion
        classes={{
          root: classes.accordion,
          rounded: classes.roundedAccordion,
        }}
        elevation={0}
        square
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon color={'primary'} />}
          aria-controls={'fine-print-content'}
        >
          <Typography
            className={classes.heading}
            variant={'h5'}
            weight={'bold'}
            color={'primary'}
          >
            {'Legal Documents'}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.linksWrapper}>
          {Object.values(LEGAL_DOCUMENT_MAP).map((link) => {
            return (
              <Link
                key={link.href}
                href={link.href}
                className={classNames({
                  [classes.mobileAgreementLink]: isMobile,
                })}
                target={'_blank'}
              >
                {link.label}
              </Link>
            );
          })}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

ClientAgreementFinePrint.defaultProps = {
  className: '',
};

ClientAgreementFinePrint.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ClientAgreementFinePrint);
